export function getB2CRequest(lang){
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/payments/b2c/';
    $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'MerchantTransactionReference' => '{{REPLACE_HERE}}',
      'ReceiverNumber' => '{{REPLACE_HERE}}',
      'Currency' => '{{REPLACE_HERE}}',
      'Amount' => '{{REPLACE_HERE}}',
      'MerchantTransactionReference' => '{{REPLACE_HERE}}',
      'ReceiverNumber' => '{{REPLACE_HERE}}',
      'Channel' => '{{REPLACE_HERE}}',
      'Reason' => '{{REPLACE_HERE}}',
      'CallBackURL' => '{{REPLACE_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    const python=`
        import requests, json
        
        url = 'https://sandbox.sasapay.app/api/v1/payments/b2c/'
        payload = {
            "MerchantCode": "your_merchant_code",
            "MerchantTransactionReference": "system_generated_transation_reference",
            "Amount": "amount",
            "Currency": "KES",
            "ReceiverNumber": "recepient_nuber",
            "Channel": "0",
            "Reason": "your reason",
            "CallBackURL": "url_callback"
        }
        headers = {
                'Authorization': f'Bearer "your_access_token" ' 
        }
        try:
            res = requests.post(url, headers=headers,data=payload)
            response = json.loads(res.text)
            print(response)
            
        except Exception as error:
        print(str(error))
    `
    const javascript=`
    const unirest = require('unirest');
    const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/payments/b2c/')
      .headers({
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjc1ODUzNzEwLCJpYXQiOjE2NzU4NTAxMTAsImp0aSI6ImY0ZjYwMjY2MjVkNjQ2ZDBiYWM0MjQzMmVhNDU4NWQyIiwidXNlcl9pZCI6Mn0.lz31rlb8odNWMX-T88wvNx4k901JgJiciazQPVb4S-k',
        'Content-Type': 'application/json'
      })
      .send(JSON.stringify({
        "MerchantCode": "*********",
        "MerchantTransactionReference": "********",
        "Currency": "KES",
        "Amount": 10,
        "ReceiverNumber": "**************",
        "Channel": "0",
        "CallBackURL": "https://posthere.io/4bdd-47d5-a54d/callback/",
        "Reason": "Test B2C"
      }))
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
    });

    `
    const java=`
    public static JSONObject businessToCustomer(String bearerToken) throws Exception {

    // NetworkCodes   SasaPay(0) 63902(MPesa) 63903(AirtelMoney) 63907(T-Kash)

    Random rand = new Random();
    int number = rand.nextInt(100);


    String url = "Endpoint";
    

    Map<String, Object> body = Map.of(
            "MerchantCode", "merchant_code",
            "Amount", 200,
            "Currency", "KES",
            "MerchantTransactionReference", "706071739",
            "ReceiverNumber", "2547******39",
            "Channel", "channel_code",
            "Reason", "description",
            "CallBackURL", "https://posthere.io/37c6-44a6-a2f4");


    URL obj = new URL(url);
    HttpURLConnection con = (HttpURLConnection) obj.openConnection();

    // Set request method
    con.setRequestMethod("POST");

    // Add bearer token to authorization header
    con.setRequestProperty("Authorization", "Bearer " + bearerToken);

    // Set request content type
    con.setRequestProperty("Content-Type", "application/json");

    // Set request body
    JSONObject jsonObject = new JSONObject(body);
    String requestBody = jsonObject.toString();

    // Send post request
    con.setDoOutput(true);
    DataOutputStream out = new DataOutputStream(con.getOutputStream());
    out.writeBytes(requestBody);
    out.flush();
    out.close();

    int responseCode = con.getResponseCode();
    if (responseCode != 200) {
        throw new Exception("Response code: " + responseCode);
    }

    // Get response
    BufferedReader in = new BufferedReader(new InputStreamReader(con.getInputStream()));
    String inputLine;
    StringBuilder response = new StringBuilder();
    while ((inputLine = in.readLine()) != null) {
        response.append(inputLine);
    }
    in.close();

    // Return response as JSONObject
    return new JSONObject(response.toString());
}
    `

    if (lang==='java') {
        return java
    } else if (lang==='python') {
        return python
    }else if (lang==='javascript') {
        return javascript
    } else {
        return laravel
    }
}
export function getB2CResponse(){
    return `
    {
      "status": true,
      "detail": "Transaction of KSH50 to 2547*****677 is being processed",
      "B2CRequestID": "4040359-0f8****1-4779-85b3-44e575166f7a",
      "ConversationID": "0f8dc1f9-6721-****-44e575166f7a",
      "OriginatorConversationID": "12****6",
      "ResponseCode": "0",
      "ResponseDescription": "Transaction of KSH50 to 2547*****677 is being processed"
    }
    `
}

//
export function getB2BRequest(lang) {
    const php=`
     $url = 'https://sandbox.sasapay.app/api/v1/payments/b2b/';
     $data = [
      'MerchantCode' => '{{REPLACE_HERE}}',
      'NetworkCode' => '{{REPLACE_HERE}}',
      'ReceiverMerchantCode' => '{{REPLACE_HERE}}',
      'MerchantTransactionReference' => '{{REPLACE_HERE}}',
      'Channel' => '{{REPLACE_HERE}}',
      'Reason' => '{{REPLACE_HERE}}',
      'CallBackURL' => '{{REPLACE_HERE}}',
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;
    `;
    const java=`
        public static JSONObject businessToBusiness(String bearerToken) throws Exception {

    Random rand = new Random();
    int number = rand.nextInt(100);

    String url = "Endpoint";

    Map<String, Object> body = Map.of(
            "MerchantCode", "merchant_code",
            "MerchantTransactionReference", "merchant_transaction_reference",
            "Currency", "KES",
            "Amount", 50,
            "ReceiverMerchantCode", "receiver_merchant_code",
            "CallBackURL", "https://posthere.io/37c6-44a6-a2f4",
            "Reason", "description");

    URL obj = new URL(url);
    HttpURLConnection con = (HttpURLConnection) obj.openConnection();

    // Set request method
    con.setRequestMethod("POST");

    // Add bearer token to authorization header
    con.setRequestProperty("Authorization", "Bearer " + bearerToken);

    // Set request content type
    con.setRequestProperty("Content-Type", "application/json");

    // Set request body
    JSONObject jsonObject = new JSONObject(body);
    String requestBody = jsonObject.toString();

    // Send post request
    con.setDoOutput(true);
    DataOutputStream out = new DataOutputStream(con.getOutputStream());
    out.writeBytes(requestBody);
    out.flush();
    out.close();

    int responseCode = con.getResponseCode();
    if (responseCode != 200) {
        throw new Exception("Response code: " + responseCode);
    }

    // Get response
    BufferedReader in = new BufferedReader(new InputStreamReader(con.getInputStream()));
    String inputLine;
    StringBuilder response = new StringBuilder();
    while ((inputLine = in.readLine()) != null) {
        response.append(inputLine);
    }
    in.close();

    // Return response as JSONObject
    return new JSONObject(response.toString());
}
    `;
    const python=`import requests, json

    url = 'https://sandbox.sasapay.app/api/v1/payments/b2b/'
    payload = {
            "MerchantCode": "your_merchant_code",
            "MerchantTransactionReference": "transation_reference",
            "Currency":"KES",
            "Amount": "amount",
            "ReceiverMerchantCode": "receiver_merchant_code",
            "CallBackURL": 'url_callback',
            "Reason": "your reason"
            }
    headers = {
        'Authorization': f'Bearer "your_access_token" ' 
        }
    try:
        res = requests.post(url, headers=headers,data=payload)
        response = json.loads(res.text)
        print(response)
    except Exception as error:
        print(str(error))`
    //
    const javascript=`
    let unirest = require('unirest');
    let req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/payments/b2b/')
      .headers({
        'Authorization': 'Bearer {{token}}',
        'Content-Type': 'application/json'
      })
      .send(JSON.stringify({
        "MerchantCode": "413554",
        "MerchantTransactionReference": "870695",
        "Currency": "KES",
        "Amount": 50,
        "ReceiverMerchantCode": "831398",
        "CallBackURL": "https://posthere.io/4bdd-47d5-a54d",
        "Reason": "Payment of transportation fee"
      }))
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
      });

    `
    if (lang==='python')
    {
        return python;
    } else if(lang==='php') {
        return php
    }
    else if(lang==='javascript') {
        return javascript
    }

    else {
        return java
    }
}

export function getB2BResponse(){
    return `
    {
      "status": true,
      "detail": "Transaction is being processed",
      "B2BRequestID": "95000-6471280a-151c-4acd-98f0-abab82b3e951",
      "ConversationID": "6471280a-151c-4acd-98f0-abab82b3e951",
      "OriginatorConversationID": "87065",
      "ResponseCode": "0",
      "ResponseDescription": true
    }
    `
}